/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The MonthlyClosingDetail model module.
 * @module model/MonthlyClosingDetail
 * @version 1.0.0
 */
export default class MonthlyClosingDetail {
  /**
   * Constructs a new <code>MonthlyClosingDetail</code>.
   * @alias module:model/MonthlyClosingDetail
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>MonthlyClosingDetail</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MonthlyClosingDetail} obj Optional instance to populate.
   * @return {module:model/MonthlyClosingDetail} The populated <code>MonthlyClosingDetail</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new MonthlyClosingDetail()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('monthly_closing_head_id')) {
        obj['monthly_closing_head_id'] = ApiClient.convertToType(data['monthly_closing_head_id'], 'Number')
      }
      if (data.hasOwnProperty('account_title_group_id')) {
        obj['account_title_group_id'] = ApiClient.convertToType(data['account_title_group_id'], 'Number')
      }
      if (data.hasOwnProperty('account_title_id')) {
        obj['account_title_id'] = ApiClient.convertToType(data['account_title_id'], 'Number')
      }
      if (data.hasOwnProperty('account_title_detail_id')) {
        obj['account_title_detail_id'] = ApiClient.convertToType(data['account_title_detail_id'], 'Number')
      }
      if (data.hasOwnProperty('occurred_on')) {
        obj['occurred_on'] = ApiClient.convertToType(data['occurred_on'], 'Date')
      }
      if (data.hasOwnProperty('price')) {
        obj['price'] = ApiClient.convertToType(data['price'], 'Number')
      }
      if (data.hasOwnProperty('remarks')) {
        obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {Number} monthly_closing_head_id
   */
  monthly_closing_head_id = undefined
  /**
   * @member {Number} account_title_group_id
   */
  account_title_group_id = undefined
  /**
   * @member {Number} account_title_id
   */
  account_title_id = undefined
  /**
   * @member {Number} account_title_detail_id
   */
  account_title_detail_id = undefined
  /**
   * @member {Date} occurred_on
   */
  occurred_on = undefined
  /**
   * @member {Number} price
   */
  price = undefined
  /**
   * @member {String} remarks
   */
  remarks = undefined
}
